const translations: Record<string, string> = {
  "ak_fin_guaranteed_buyer": "Guaranteed buyer",
  "ak_fin_trader": "Trader",
  "ak_fin_aggregator": "Aggregator",
  "ak_fin_green_tariff": "Green tariff",
  "ak_fin_bilateral_contract": "Bilateral contract",
  "ak_fin_fixed": "Fixed",
  "ak_fin_formula": "Formula",
  "ak_fin_dam": "DAM",
  "ak_fin_other_index": "Other index",
  "ak_fin_draft": "Draft",
  "ak_fin_active": "Active",
  "ak_fin_completed": "Completed",
  "ak_fin_uah": "UAH",
  "ak_fin_finance": "Finance",
  "ak_fin_financial_result": "Financial result",
  "ak_fin_select_a_station_in_the_header_to_see": "Select a station in the header to see the financial result.",
  "ak_fin_loading": "Loading…",
  "ak_fin_lost_benefit": "Lost benefit",
  "ak_fin_the_indicator_will_be_implemented_in_t": "The indicator will be implemented in the next release. For now the lost benefit is 0 UAH and does not affect the financial result calculation.",
  "ak_fin_financial_result_comprehensive": "Financial result (comprehensive)",
  "ak_fin_in_the_next_release_planned_and_actual": "In the next release: planned and actual income, imbalances, lost benefit, TSO/DSO compensation, BESS operating result and the total financial result.",
  "ak_fin_next_release": "next release",
  "ak_fin_0_uah": "0 UAH",
  "ak_fin_with_vat": "incl. VAT",
  "ak_fin_without_vat": "excl. VAT",
  "ak_fin_planned_income": "Planned income",
  "ak_fin_imbalances_actual": "Imbalances (actual)",
  "ak_fin_imbalances": "Imbalances",
  "ak_fin_failed_to_save": "Failed to save",
  "ak_fin_actual_settlement_from_the_group": "Actual settlement from the group",
  "ak_fin_imbalance_volume_positive_surplus_nega": "Imbalance volume: positive - surplus, negative - deficit. The amount may be left empty - it will be calculated as volume × price.",
  "ak_fin_hr": "Hr",
  "ak_fin_imbalance_kwh": "Imbalance, kWh",
  "ak_fin_price_uah_mwh": "Price, UAH/MWh",
  "ak_fin_amount_uah": "Amount, UAH",
  "ak_fin_close": "Close",
  "ak_fin_saving": "Saving…",
  "ak_fin_save": "Save",
  "ak_fin_hour": "Hour {{label}}",
  "ak_fin_plan_mwh": "Plan: {{v}} MWh",
  "ak_fin_delivery_mwh": "Delivery: {{v}} MWh",
  "ak_fin_imbalance_mwh": "Imbalance: {{v}} MWh",
  "ak_fin_day": "Day {{label}}",
  "ak_fin_operational": "Operational: {{v}}",
  "ak_fin_plan": "Plan",
  "ak_fin_delivery": "Delivery",
  "ak_fin_imbalance": "Imbalance",
  "ak_fin_operational_result": "Operational result",
  "ak_fin_mms_release_mwh": "MMS release: {{v}} MWh",
  "ak_fin_price_uah_mwh_2": "Price: {{v}} UAH/MWh",
  "ak_fin_price_type": "Price type: {{v}}",
  "ak_fin_planned_income_2": "Planned income (excl. VAT): {{v}}",
  "ak_fin_current_cost": "Current cost: {{v}}",
  "ak_fin_actual_cost": "Actual cost: {{v}}",
  "ak_fin_difference": "Difference: {{v}}",
  "ak_fin_k": "k",
  "ak_fin_release_mwh": "Release, MWh",
  "ak_fin_income_uah": "Income, UAH",
  "ak_fin_cost_uah": "Cost, UAH",
  "ak_fin_mms_release": "MMS release",
  "ak_fin_current_cost_2": "Current cost",
  "ak_fin_actual_cost_2": "Actual cost",
  "ak_fin_metric_hour": "Metric \\ Hour",
  "ak_fin_metric_date": "Metric \\ Date",
  "ak_fin_the_accepted_mms_release_schedule": "— the accepted MMS release schedule",
  "ak_fin_per_contract_terms_gt_fixed_formula": "— per contract terms (GT / fixed / formula)",
  "ak_fin_release_price": "release × price",
  "ak_fin_release_price_release": "Σ(release × price) / Σ release",
  "ak_fin_total": "Total",
  "ak_fin_mms_release_mwh_2": "MMS release, MWh",
  "ak_fin_weighted_avg_price_uah_mwh": "Weighted avg. price, UAH/MWh",
  "ak_fin_planned_income_uah": "Planned income, UAH (excl. VAT)",
  "ak_fin_accumulated_uah": "Accumulated, UAH",
  "ak_fin_no_data_for_the_period": "No data for the period.",
  "ak_fin_no_data_for_the_chart": "No data for the chart",
  "ak_fin_sale_price": "Sale price",
  "ak_fin_weighted_average": "Weighted average",
  "ak_fin_for_the_day": "for the day · {{d}}",
  "ak_fin_for_the_day_2": "for the day",
  "ak_fin_as_of": "as of {{d}}",
  "ak_fin_as_of_today": "as of today",
  "ak_fin_imbalances_since_month_start": "Imbalances since month start",
  "ak_fin_economic_effect": "Economic effect",
  "ak_fin_after_the_month_is_closed": "after the month is closed",
  "ak_fin_current_cost_uah": "Current cost, UAH",
  "ak_fin_actual_cost_uah": "Actual cost, UAH",
  "ak_fin_difference_uah": "Difference, UAH",
  "ak_fin_current_month": "current month",
  "ak_fin_imbalance_result_actual": "Imbalance result (actual)",
  "ak_fin_current_imbalance_result": "Current imbalance result",
  "ak_fin_month_closed_auto": "Month closed (auto)",
  "ak_fin_month_closed": "Month closed",
  "ak_fin_month_open": "Month open",
  "ak_fin_manually_close_reopen_the_month": "Manually close/reopen the month",
  "ak_fin_reopen_month": "Reopen month",
  "ak_fin_close_month": "Close month",
  "ak_fin_after_the_month_is_closed_the_actual_i": "After the month is closed, the actual imbalance cost and the economic effect are shown.",
  "ak_fin_before_the_month_is_closed_the_platfor": "Before the month is closed, the platform automatically shows the current imbalance cost (operational or refined).",
};

export default translations;
